import React from "react";
import "./matchOddsPills.css";

/** Home/Away odds pills — same layout as Favorites page cards. */
export default function MatchOddsPills({
  homeLabel = "Home",
  awayLabel = "Away",
  homeDisplay,
  awayDisplay,
  className = "",
}) {
  return (
    <div className={`match-odds-pills ${className}`.trim()}>
      <span className="match-odds-pill">
        <small>{homeLabel}</small>
        {homeDisplay ?? "—"}
      </span>
      <span className="match-odds-pill">
        <small>{awayLabel}</small>
        {awayDisplay ?? "—"}
      </span>
    </div>
  );
}
